var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Section',{attrs:{"width":"md"}},_vm._l((_vm.slice.items),function(item,index){return _c('div',{key:index,staticClass:"container"},[_c('span',{staticClass:"container-number"},[_vm._v(_vm._s(item.number))]),_vm._v(" "),_c('span',{staticClass:"container-text"},[_vm._v(_vm._s(_vm.$prismic.asText(item.text)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }